module.exports = __webpack_public_path__ + "img/旺店-app下载页.6a0d42ca.png";